import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import img13 from "../../assets/images/fcer-1.jpg";
import img14 from "../../assets/images/fcer-2.jpg";
import "../qcertificate/QualityCertificate.css";

// Import the background image
import backgroundImage from "../../assets/images/slide2.jpeg";
import CertificateSlider from '../../component/certificateslider/CertificateSlider';
import { Helmet } from 'react-helmet';

const QualityCertificate = () => {
    const certificationSections = [
        {
            title: 'Enlistment in Approved List of Models and Manufacturers (ALMM) Certifications by the Bureau of Indian Standards (BIS):',
            certifications: ['IS 14286 : 2010', 'IEC 61215 : 2005', 'IS/IEC 61730 (Part 1) : 2004', 'IS/IEC 61730 (Part 2) : 2004'],
        },

        {
            title: 'Certifications as per UL Standards:',
            certifications: [
                'UL 61215-1 : 2021 Ed 2',
                'UL 61215-2 : 2021 Ed 2',
                'UL 61730-1 : 2017 Ed 1',
                'UL 61730-2 : 2017 Ed 1',

            ],
        },
        {
            title: '  Certifications as per EN Standards:',
            certifications: ['EN 61730-1 : 2018',
                'EN 61730-2 : 2018'],
        },
        {
            title: ' Certifications as per IEC Standards:',
            certifications: ['IEC 61215-1 : 2021', 'IEC 61215-1-1 : 2021', 'IEC 61215-2 : 2021', 'IEC 61730-1 : 2016', 'IEC 61730-2 : 2016'],
        },
        {
            title: 'Other Important Certifications',
            certifications: [
                'IEC 61701 : 2020 Ed 3 – Salt mist corrosion testing',
                'IEC 62716 : 2013 Ed 1 – Ammonia corrosion testing',
                'IEC TS 62804-1 : 2015 – Potential Induced Degradation Test',
                'IEC 62759-1 : 2022 – Transportation Test',
                'IEC 60068-2-68 – Sand and dust test',
                'IEC 60068-2-14 – Ambient temperature changes',
                'IEC 60068-2-38 – Composite temperature∕humidity cyclic test (HF10)',
                'IEC 61853-1 : 2011',
            ],
        },
    ];

    const sectionStyle = {
        backgroundImage: `url(${backgroundImage})`,
        backgroundColor: '#a20000',
        backgroundBlendMode: 'multiply',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        height: '250px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
    };

    return (
        <>
            {/* <Helmet>
                <title>Best high quality solar materials</title>
                <meta name="description" content="Explore the best high-quality solar materials with Gautam Solar's advanced Mono PERC and TOPCon modules. Manufactured in India across four automated plants, they deliver superior power density (up to 23.7% efficiency), low degradation, and long-term durability." />

                <meta name="keywords" content="best of manufacturing practices, best high quality solar materials, best solar panels, solar panels suppliers near me" />

                <link rel="canonical" href="https://gautamsolar.com/quality/" />
            </Helmet> */}

            <Helmet>
                <title>
                    Solar Panel Quality & Certifications | Gautam Solar
                </title>

                <meta
                    name="description"
                    content="Explore Gautam Solar's solar module quality standards and certifications, including ALMM, BIS, UL, EN, IEC, ISO 9001:2015 and ISO 14001:2015."
                />

                <link
                    rel="canonical"
                    href="https://gautamsolar.com/quality/"
                />

                <meta
                    name="robots"
                    content="index, follow"
                />


                {/* =====================================================
      OPEN GRAPH
  ====================================================== */}

                <meta
                    property="og:title"
                    content="Solar Panel Quality & Certifications | Gautam Solar"
                />

                <meta
                    property="og:description"
                    content="Explore Gautam Solar's solar module quality standards and certifications, including ALMM, BIS, UL, EN, IEC, ISO 9001:2015 and ISO 14001:2015."
                />

                <meta
                    property="og:url"
                    content="https://gautamsolar.com/quality/"
                />

                <meta
                    property="og:type"
                    content="website"
                />

                <meta
                    property="og:site_name"
                    content="Gautam Solar"
                />


                {/* =====================================================
      ORGANIZATION
      Establishes Gautam Solar as the company/entity.
  ====================================================== */}

                <script type="application/ld+json">
                    {JSON.stringify({
                        "@context": "https://schema.org",

                        "@type": "Organization",

                        "@id": "https://gautamsolar.com/#organization",

                        "name": "Gautam Solar",

                        "url": "https://gautamsolar.com/",

                        "description":
                            "Gautam Solar is an Indian solar module manufacturer providing Mono PERC and N-type TOPCon solar modules.",

                        "address": {
                            "@type": "PostalAddress",
                            "addressCountry": "IN"
                        },

                        "contactPoint": {
                            "@type": "ContactPoint",
                            "contactType": "customer service",
                            "availableLanguage": [
                                "English",
                                "Hindi"
                            ]
                        },

                        "sameAs": [
                            "https://www.facebook.com/gautamsolarprivatelimited",
                            "https://www.instagram.com/gautam_solar/",
                            "https://www.linkedin.com/company/gautam-solar-group/",
                            "https://www.youtube.com/@GautamSolarOfficial"
                        ],

                        "slogan": "Quality at the heart of everything we do"
                    })}
                </script>


                {/* =====================================================
      WEBSITE
  ====================================================== */}

                <script type="application/ld+json">
                    {JSON.stringify({
                        "@context": "https://schema.org",

                        "@type": "WebSite",

                        "@id": "https://gautamsolar.com/#website",

                        "url": "https://gautamsolar.com/",

                        "name": "Gautam Solar",

                        "publisher": {
                            "@id": "https://gautamsolar.com/#organization"
                        }
                    })}
                </script>


                {/* =====================================================
      WEBPAGE
  ====================================================== */}

                <script type="application/ld+json">
                    {JSON.stringify({
                        "@context": "https://schema.org",

                        "@type": "WebPage",

                        "@id": "https://gautamsolar.com/quality/#webpage",

                        "url": "https://gautamsolar.com/quality/",

                        "name":
                            "Solar Panel Quality & Certifications | Gautam Solar",

                        "description":
                            "Gautam Solar's solar module quality standards and certifications, including ALMM, BIS, UL, EN, IEC, ISO 9001:2015 and ISO 14001:2015.",

                        "inLanguage": "en",

                        "isPartOf": {
                            "@id": "https://gautamsolar.com/#website"
                        },

                        "publisher": {
                            "@id": "https://gautamsolar.com/#organization"
                        },

                        "about": {
                            "@type": "Thing",

                            "name":
                                "Solar Module Quality Standards and Certifications",

                            "description":
                                "Quality standards, certifications and testing standards associated with Gautam Solar solar modules and manufacturing facilities."
                        },

                        "breadcrumb": {
                            "@id":
                                "https://gautamsolar.com/quality/#breadcrumb"
                        }
                    })}
                </script>


                {/* =====================================================
      QUALITY STANDARDS & CERTIFICATIONS
  ====================================================== */}

                <script type="application/ld+json">
                    {JSON.stringify({
                        "@context": "https://schema.org",

                        "@type": "ItemList",

                        "@id":
                            "https://gautamsolar.com/quality/#certifications",

                        "name":
                            "Gautam Solar Quality Standards and Certifications",

                        "description":
                            "Quality standards, certifications and testing standards associated with Gautam Solar solar modules and manufacturing facilities.",

                        "numberOfItems": 7,

                        "itemListElement": [

                            {
                                "@type": "ListItem",

                                "position": 1,

                                "name": "ALMM",

                                "description":
                                    "Enlistment in the Approved List of Models and Manufacturers (ALMM), including IS 14286:2010, IEC 61215:2005 and IS/IEC 61730 Part 1 and Part 2:2004."
                            },

                            {
                                "@type": "ListItem",

                                "position": 2,

                                "name": "UL Standards",

                                "description":
                                    "UL 61215-1:2021 Ed 2, UL 61215-2:2021 Ed 2, UL 61730-1:2017 Ed 1 and UL 61730-2:2017 Ed 1."
                            },

                            {
                                "@type": "ListItem",

                                "position": 3,

                                "name": "EN Standards",

                                "description":
                                    "EN 61730-1:2018 and EN 61730-2:2018."
                            },

                            {
                                "@type": "ListItem",

                                "position": 4,

                                "name": "IEC Standards",

                                "description":
                                    "IEC 61215-1:2021, IEC 61215-1-1:2021, IEC 61215-2:2021, IEC 61730-1:2016 and IEC 61730-2:2016."
                            },

                            {
                                "@type": "ListItem",

                                "position": 5,

                                "name":
                                    "Other Important Certifications and Tests",

                                "description":
                                    "IEC 61701:2020 Ed 3 for salt mist corrosion testing, IEC 62716:2013 Ed 1 for ammonia corrosion testing, IEC TS 62804-1:2015 for Potential Induced Degradation testing, IEC 62759-1:2022 for transportation testing, IEC 60068-2-68 for sand and dust testing, IEC 60068-2-14 for ambient temperature changes, IEC 60068-2-38 for composite temperature and humidity cyclic testing, and IEC 61853-1:2011."
                            },

                            {
                                "@type": "ListItem",

                                "position": 6,

                                "name": "ISO 9001:2015",

                                "description":
                                    "Quality Management System certification for Gautam Solar's manufacturing facilities."
                            },

                            {
                                "@type": "ListItem",

                                "position": 7,

                                "name": "ISO 14001:2015",

                                "description":
                                    "Environmental Management System certification for Gautam Solar's manufacturing facilities."
                            }
                        ]
                    })}
                </script>


                {/* =====================================================
      BREADCRUMB
  ====================================================== */}

                <script type="application/ld+json">
                    {JSON.stringify({
                        "@context": "https://schema.org",

                        "@type": "BreadcrumbList",

                        "@id":
                            "https://gautamsolar.com/quality/#breadcrumb",

                        "itemListElement": [

                            {
                                "@type": "ListItem",

                                "position": 1,

                                "name": "Home",

                                "item":
                                    "https://gautamsolar.com/"
                            },

                            {
                                "@type": "ListItem",

                                "position": 2,

                                "name":
                                    "Quality & Certifications",

                                "item":
                                    "https://gautamsolar.com/quality/"
                            }
                        ]
                    })}
                </script>

            </Helmet>


            <h1 className="sr-only">Product Certifications</h1>

            <section
                className="elementor-section elementor-top-section elementor-element elementor-element-d29e141 elementor-section-full_width elementor-section-stretched elementor-section-height-default elementor-section-height-default"
                data-id="d29e141"
                data-element_type="section"
                data-settings="{&quot;background_background&quot;:&quot;classic&quot;,&quot;stretch_section&quot;:&quot;section-stretched&quot;}"
                style={{ ...sectionStyle }}
            >
                <div className="elementor-background-overlay"></div>
                <Container className="elementor-container elementor-column-gap-no">
                    <Row className="elementor-row">
                        <Col className="elementor-column elementor-col-12 elementor-top-column elementor-element elementor-element-0a1c64f" data-id="0a1c64f" data-element_type="column">
                            <div className="elementor-column-wrap elementor-element-populated">
                                <div className="elementor-widget-wrap">
                                    <div
                                        className="elementor-element elementor-element-b12b60d elementor-widget elementor-widget-modina_section_title"
                                        data-id="b12b60d"
                                        data-element_type="widget"
                                        data-widget_type="modina_section_title.default"
                                    >
                                        <div className="elementor-widget-container">
                                            <div className="block-contents text-center">
                                                <h2 className='resText' >Quality Certificate</h2>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
            <section id="quality-certificate">
                <Container className='py-5 col-lg-11 align-items-center' fluid>
                    <Row>
                        <Col md={12}>
                            <div>
                                <p style={{ fontSize: "18px" }}>
                                    Quality is at the heart of everything we do. From sourcing of high quality raw materials to employing advanced automatic machines and best of manufacturing practices for producing solar panels to ensuring safe delivery, we meet strict standards for quality.
                                </p>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
            <CertificateSlider />


            <Container className="elementor-container elementor-column-gap-default py-5">
                <h5 style={{ justifyContent: "center", alignItems: "center" }}>These include:</h5>
                <Row>
                    <Col md={6}>
                        {certificationSections.slice(0, 3).map((section, index) => (
                            <div key={index} className="text-left mb-4">
                                <p className="mb-2 ">
                                    <strong>{section.title}</strong>
                                </p>
                                <ul className="list-order">
                                    {section.certifications.map((certification, innerIndex) => (
                                        <li key={innerIndex}>{certification}</li>
                                    ))}
                                </ul>
                            </div>
                        ))}
                    </Col>
                    <Col md={6}>
                        {certificationSections.slice(3).map((section, index) => (
                            <div key={index} className="text-left mb-4">
                                <p className="mb-2">
                                    <strong>{section.title}</strong>
                                </p>
                                <ul className="list-order">
                                    {section.certifications.map((certification, innerIndex) => (
                                        <li key={innerIndex}>{certification}</li>
                                    ))}
                                </ul>
                            </div>
                        ))}
                    </Col>
                </Row>
            </Container>




            <Container className="py-5">
                <div className="row py-5" style={{ overflowX: 'hidden' }}>
                    <div className="col-lg-10 col-md-12 mx-auto text-center">
                        <h2 className="resText" style={{ position: 'relative', color: 'black' }}>
                            <span style={{ position: 'absolute', top: '-15px', left: '50%', transform: 'translateX(-50%)', borderBottom: '2px solid #faab04', width: '45px' }}></span>
                            Factory <span style={{ fontWeight: 'bold', color: '#a20000' }}>Certifications</span>
                        </h2>
                    </div>
                </div>
            </Container>
            <Container className='py-3 col-lg-11 align-items-center' fluid>
                <Row>
                    <Col md={12}>
                        <div className='py-2'>
                            <p style={{ fontSize: "18px" }}>
                                Our 4 state-of-the-art factories have received the following certifications:
                            </p>
                        </div>
                        <div>
                            <ul>
                                <li>
                                    ISO 9001 : 2015 for Quality Management System
                                </li>
                                <li>
                                    ISO 14001 : 2015 for Environmental Management System
                                </li>
                            </ul>
                        </div>
                    </Col>
                </Row>
            </Container>


            <Card className='my-5'>
                <Card.Body>
                    <Row >
                        <Col md={6}>
                            <img
                                src={img13}
                                className="img-fluid"
                                alt='image13'

                            />
                        </Col>
                        <Col md={6}>
                            <img
                                src={img14}
                                className="img-fluid"
                                alt='image14'

                            />
                        </Col>
                    </Row>
                </Card.Body>
            </Card>
        </>
    );
};

export default QualityCertificate;
